import {
  IQuoteBehaviorSpecifiable, instanceOfIQuoteBehaviorSpecifiable,
  IImageContent,
} from "../../../../documaker/domain/format/objects";
import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";
import { ElementTypes } from "./ElementTypes";

export interface IImageDrawableObject extends IRectangleCoordinatableObject, IQuoteBehaviorSpecifiable {
  formatId: number;
  imageContent: IImageContent;
  temporaryImageContent: IImageContent;
}

export function instanceOfIImageDrawableObject<T extends IImageDrawableObject>(instance: any, type: ElementTypes): instance is IImageDrawableObject {
  return instance
      && (instance.formatId !== undefined)
      && (instance.imageContent !== undefined)
      && (instance.temporaryImageContent !== undefined)
      && instanceOfIQuoteBehaviorSpecifiable(instance)
      && instanceOfIRectangleCoordinatableObject<T>(instance, type);
}
